import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NJDocData, NJDocDefTemplate, DOData, componentVM } from '../DOData';
import { faTrashAlt, faTrash, faPrint, faPlus, faMinus, faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Event } from '@angular/router';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';

@Component({
    selector: 'cy-previous-answer-button',
    templateUrl: './previous-answer-button.component.html',
    styleUrls: ['./previous-answer-button.component.css']
})
export class PreviousAnswerButtonComponent implements OnInit {
    
    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() customParameters: any
    @Input() DocData: NJDocData;

    _isEnabled: boolean;
    get isEnabled(): boolean
    {
        return this._isEnabled;
    }
    @Input() set isEnabled(value: boolean)
    {
        this._isEnabled = value;
        this.isDisabled = !this._isEnabled;
    }
    
    @Input() isInGroup: boolean=false;
    isHidden: boolean;
    isDisabled: boolean;
    @Input() PreviousDropdownValue : string;
    @Input() PreviousCommentValue: string;
    @Input() PreviousLabelValue: string;
    ButonIcon = faTrashAlt;
    butClass: string;
    StylesButton: any;
    StylesCell: any;
    url: string;
    @Output() clickPrevBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tabEvent: EventEmitter<componentVM> = new EventEmitter<componentVM>();
    @Output() buttonAfterViewInit: EventEmitter<PreviousAnswerButtonComponent> = new EventEmitter<PreviousAnswerButtonComponent>();
    elemOnBlurGoto: any

    constructor(private data: DocDefPrimLibService) { }

    ngOnInit() {
        if (this.customParameters['StylesButton'] != null) {
            let styles = this.data.replaceAll(this.customParameters['StylesButton'], "'", '"');
            this.StylesButton = JSON.parse(styles);
        }
        if (this.customParameters['StylesCell'] != null) {
            let styles = this.data.replaceAll(this.customParameters['StylesCell'], "'", '"');
            this.StylesCell = JSON.parse(styles);
        }
        this.butClass = this.customParameters['ButClass']
        switch (this.customParameters['ButonIcon']) {
            case 'faTrashAlt':
                this.ButonIcon = faTrashAlt;
                break;
            case 'faTrash':
                this.ButonIcon = faTrash;
                break;
            case 'faPrint':
                this.ButonIcon = faPrint;
                break;
            case 'faPlus':
                this.ButonIcon = faPlus;
                break;
            case 'faMinus':
                this.ButonIcon = faMinus;
                break;
            case 'faTimes':
                this.ButonIcon = faTimes;
                break;
            case 'faSearch':
                this.ButonIcon = faSearch;
                break;
            default:
                this.ButonIcon = undefined;
                break;
        }
        
        // This will disable the button if Disable = 'True' in the Template
        if (this.customParameters['Disable'])
            if (this.customParameters['Disable'] === 'True')
                this.isEnabled = false;

        this.setHiddenStatus();
        this.setReadonlyStatus(this.isEnabled);
        if (this.customParameters['src'])
        this.url = this.data.apiBaseName + this.customParameters['src'];
        if (this.customParameters['Tab']) {
            let message: componentVM = new componentVM();
            message.thisComponent = this;
            message.tag = this.customParameters['Tab']
            this.tabEvent.emit(message);
        }
    }
    setOnBlurGoto(element: any) {
        this.elemOnBlurGoto = element;
    }
    onBlurBut(event: any) {
        if (this.elemOnBlurGoto) {
            //event.stopPropagation();
            event.preventDefault();
            event.stopImmediatePropagation();
            this.elemOnBlurGoto.setFocus();
            return false;
        }
    }
    onDoButtonClick()
    {
        if (!this.isDisabled)
        {
            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = this.DocData;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            DOMessage.customParameters = this.customParameters;
            DOMessage.isEnabled = this.isDisabled;
            //DOMessage.PreviousTitleValue = this.PreviousTitleValue;
            DOMessage.PreviousDropdownValue = this.PreviousDropdownValue;
            DOMessage.PreviousCommentValue = this.PreviousCommentValue;
            DOMessage.PreviousLabelValue = this.PreviousLabelValue;
            this.clickPrevBut.emit(DOMessage);

            if (this.isInGroup)
                this.butClass = (this.customParameters['ButClass']).trim() + ' active';
        }
    }
    public resetButClass() {
        this.butClass = this.customParameters['ButClass'];
    }
    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["HiddenIfMissingSecCode"]) {
            this.data.checkIfCodeInUserSecurity(this.customParameters["HiddenIfMissingSecCode"], this.data.LoaderKey).subscribe((ret: boolean) => {
                if (ret) {
                    this.isHidden = false;
                }
                else {
                    this.isHidden = true;
                }
            });
        }
        else this.isHidden = false;
    }

    setReadonlyStatus(isEnabled: boolean) {
        if (this.customParameters.isReadOnly == 'Yes' || !isEnabled)
            this.isDisabled = true;
        //has a youth been selected when it's required
        else if (this.customParameters["DisabledIfMissingYouthId"]) {
        }
        //is the the required seccode in the user's credentials
        else if (this.customParameters["DisabledIfMissingSecCode"]) {
            this.data.checkIfCodeInUserSecurity(this.customParameters["DisabledIfMissingSecCode"], this.data.LoaderKey).subscribe((ret: boolean) => {
                if (ret) {
                    this.isDisabled = false;
                }
                else {
                    this.isDisabled = true;
                }
            });
        }
        else if (this.customParameters["DisabledIfHasSecCode"]) {
            this.data.checkIfCodeInUserSecurity(this.customParameters["DisabledIfHasSecCode"], this.data.LoaderKey).subscribe((ret: boolean) => {
                if (ret) {
                    this.isDisabled = true;
                }
                else {
                    this.isDisabled = false;
                }
            });
        }
        else this.isDisabled = false;
    }
    getTooltip(): string {
        let hadDropdown: boolean = true;
        let hadComment: boolean = true;
        if (this.PreviousDropdownValue == "Previous Answer: No previous answer.") {
            hadDropdown = false;
        }
        if (this.PreviousCommentValue == "Previous Comment: No previous answer.") {
            hadComment = false;
        }
        if (!hadDropdown && !hadComment) {
            return "No prior assessments.";
        }
        else {
            let tooltip: string;
            tooltip = `${this.PreviousDropdownValue}
            
                        ${this.PreviousCommentValue}`;
            return tooltip;
        }
    }
    ngAfterViewInit() {
        this.buttonAfterViewInit.emit(this);
    }
}

